module.exports = __webpack_public_path__ + "static/media/Publika 1.a2f75df2.jpg";